import React from 'react';
import styled from 'styled-components';
import CountUp from 'react-countup';
import { Percents } from '@components/percent/percent';
import { skeletonCounter } from './utils/counterSkeleton';
import { getColor, getIcon } from '../../utils/counter';

import './counter.css';

const Card = styled.article`
  min-width: 220px;
  width: 100%;
  height: 72px; /* Voy a borrar esto aunque a Meli no le guste :) */
  padding: 12px 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  transition: transform 0.2s;
  /* cursor: pointer; */
  border: ${(props) => props.border || 'none'};
  & ~ div {
    position: absolute !important;
    margin-top: 8px;
    font-size: 12px;
  }
`;

const CardIcon = styled.span`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  margin-top: 8px;
  font-size: 32px;
  font-weight: 400 !important;
  display: flex;
  align-self: flex-start;
  align-items: center;
  justify-content: center;

  &.hr-Interview {
    margin-right: 8px !important;
    font-size: 32px !important;
  }
`;

const CardInfo = styled.span`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  /* margin-top: -10px; SI NECESITAN QUE LOS NUMEROS ESTEN MAS HACIA ARRIBA, DESCOMENTEN ESTA LINEA */
  & .countUp {
    font-weight: 700;
    font-size: 18px;
  }
`;

const CardInfoTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #9a9a9a;
  width: 100%;
`;

const CardInfoPercent = styled.span`
  display: flex;
  gap: 2px;
  align-items: center;
`;

export const CounterCard = ({ border = null, title, number, percent, isLoading }) => {
  const percentValue = () => {
    if (percent >= 0) {
      return true;
    }
    return false;
  };

  const getPercentColor = () => {
    if (percentValue()) {
      return 'green';
    }
    return 'red';
  };

  const getPercentIcon = () => {
    if (percentValue()) {
      return 'hr-Arrow-rise';
    }
    return 'hr-Arrow-drop';
  };

  if (isLoading) {
    return skeletonCounter();
  }

  return (
    <Card border={border}>
      <CardIcon className={`${getIcon(title)}`} style={{ color: getColor(title) }} />
      <CardInfo>
        <CountUp
          className='countUp'
          end={number || 0}
          style={{ color: getColor(title) }}
          duration={2}
          delay={1}
        />
        <CardInfoTitle>{title}</CardInfoTitle>
        {percent && (
          <CardInfoPercent className='card-counter-text-percent'>
            <Percents color={getPercentColor()} icon={getPercentIcon()} percent={percent} />
          </CardInfoPercent>
        )}
      </CardInfo>
    </Card>
  );
};
